<mat-card class="validate-card">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
        <mat-icon class="mat-icon-rtl-mirror">{{ icon }}</mat-icon>
    </mat-card-header>
    <mat-card-content>
        {{ message }}
    </mat-card-content>
    <mat-card-actions>
        <button *ngIf="okButton.code.length !== 0" mat-button (click)="close(okButton.code)">{{ okButton.label }}</button>
        <button *ngIf="otherButton.code.length !== 0" mat-button (click)="close(otherButton.code)">{{ otherButton.label }}</button>
        <button *ngIf="cancelButton.code.length !== 0" mat-button (click)='close(cancelButton.code)'>{{ cancelButton.label}}</button>
    </mat-card-actions>
  </mat-card>
